import { takeLatest, delay } from 'redux-saga'
import { put, call, take, select, fork, cancel } from 'redux-saga/effects'
import { UPDATE_DISTANCE_ON_INTERVAL, CLEAR_UPDATE_DISTANCE_ON_INTERVAL } from 'actions/calculatorActionTypes'
import { updateCalculatorAction } from 'actions/calculatorActions'
import { currentCameraSelector } from 'selectors'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export function* startUpdateInterval({ increasing, id }) {
  while (true) {
    yield call(delay, 75)
    const { currentCamera: { distance } } = yield select(currentCameraSelector)
    yield put(updateCalculatorAction(`${distance + (increasing ? 10 : -10)}`, 'distance', id, true))
  }
}

export function* updateDistanceOnInterval(action) {
  try {
    const { increasing, id } = action
    const interval = yield fork(startUpdateInterval, { increasing, id })
    yield take(CLEAR_UPDATE_DISTANCE_ON_INTERVAL)
    yield cancel(interval)
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function* watchUpdateDistanceOnInterval() {
  yield* takeLatest(UPDATE_DISTANCE_ON_INTERVAL, updateDistanceOnInterval)
}



// WEBPACK FOOTER //
// ./src/sagas/updateDistanceOnIntervalSaga.js